import React from "react";
import styles from "./style.module.css";
import { BackIcon } from "../../../assets";
import { useDispatch, useSelector } from "react-redux";
import { setCheckoutVisibility } from "../../../redux/slices/checkoutSlice";
import { RootState } from "../../../redux/store";

interface ICartContentHeaderProps
{
  headerTitle?: string;
  showBackButton?: boolean;
}

// export const CartContentHeader = ({ itemCount }: { itemCount: number }) => {
  export const CartContentHeader: React.FC<ICartContentHeaderProps> = ({headerTitle = false, showBackButton}) => {
  // const itemText = itemCount === 1 ? "Item" : "Items";

  const dispatch = useDispatch();
  const isBillingOpen = useSelector((state: RootState) => state.CheckoutState.isCheckoutOpen);
  const handleBackClick = () => 
  {
    if(isBillingOpen)
    {
      dispatch(setCheckoutVisibility(false));
    }
  }

  return (
    <div className={styles.container} >
      {/* Cart ({itemCount} {itemText}) */}
      <div className={styles.txtCont} onClick={handleBackClick}>
      {showBackButton && <BackIcon className={styles.icon}/>}
      {headerTitle}
      </div>
    </div>
  );
};